import GET_BANK_SLIP_URL from './getBankSlipUrl.gql';

export default GET_BANK_SLIP_URL;
export {
  GET_BANK_SLIP_URL,
};
